import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import {
  DisabilityStore,
  DisabilityDetails,
  DisabilityDashboardItem
} from './types'

export const useDisabilityStore = create<DisabilityStore>()(
  devtools(set => ({
    getUserDisabilityDetails: async (userId: number) => {
      try {
        const endpoint = `/user/${userId}/details/disability`
        const response = await http.get(endpoint)

        return response as DisabilityDetails
      } catch (error) {
        console.error('Error fetching disability details:', error)
        return null
      }
    },
    getDisabilityDashboard: async () => {
      try {
        const endpoint = `/dashboard/disability`
        const response = await http.get(endpoint)

        return response as DisabilityDashboardItem[]
      } catch (error) {
        console.error('Error fetching disability dashboard:', error)
        return null
      }
    }
  }))
)
